module.exports = __webpack_public_path__ + "img/pattern_certificate@2x.1db9aea9.png";